import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/business";

export default function WhatsAppButton() {
    const [showTip, setShowTip] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setShowTip(true), 2500);
        const t2 = setTimeout(() => setShowTip(false), 7000);
        return () => {
            clearTimeout(t);
            clearTimeout(t2);
        };
    }, []);

    return (
        <div className="fixed bottom-24 right-4 z-[60] flex items-center gap-3 sm:bottom-6 sm:right-6">
            <AnimatePresence>
                {showTip && (
                    <motion.span
                        initial={{ opacity: 0, x: 8 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 8 }}
                        className="hidden border border-line bg-paper px-3 py-2 font-mono text-[10px] uppercase tracking-[0.15em] text-ink shadow-sm sm:block"
                    >
                        Fale conosco
                    </motion.span>
                )}
            </AnimatePresence>
            <a
                href={WHATSAPP_URL}
                data-testid="whatsapp-float-button"
                aria-label="Fale conosco pelo WhatsApp"
                className="flex h-14 w-14 items-center justify-center rounded-full bg-accent text-paper shadow-lg transition-transform duration-300 hover:scale-105"
            >
                <MessageCircle size={22} />
            </a>
        </div>
    );
}
